module.exports = __webpack_public_path__ + "static/media/CircularStd-BlackItalic.8f80cd37.woff2";